import { useState } from "react";
import { SortOptions } from "@/shared/components/table/GenericTable";
import { AdminAccountControllerGetAllQueryParams, Nullable } from "service";

export type TeamMemberSortField = NonNullable<
  AdminAccountControllerGetAllQueryParams["sort"]
>;

export interface TeamMembersFilterState {
  sortOptions: Nullable<SortOptions>;
}

export type UpdateTeamMembersFilter = <K extends keyof TeamMembersFilterState>(
  key: K,
  value: TeamMembersFilterState[K],
) => void;

const useTeamMembersFilters = () => {
  const [filters, setFilters] = useState<TeamMembersFilterState>({
    sortOptions: null,
  });

  const updateFilter: UpdateTeamMembersFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const sortQueryParams: Pick<
    AdminAccountControllerGetAllQueryParams,
    "sort" | "order"
  > = {
    ...(filters.sortOptions?.sortBy && {
      sort: filters.sortOptions.sortBy as TeamMemberSortField,
    }),
    ...(filters.sortOptions?.direction && {
      order: filters.sortOptions.direction,
    }),
  };

  return { filters, updateFilter, sortQueryParams };
};

export default useTeamMembersFilters;
